import { render } from "./imageUpload.vue?vue&type=template&id=fef8cd04&scoped=true"
import script from "./imageUpload.vue?vue&type=script&lang=js"
export * from "./imageUpload.vue?vue&type=script&lang=js"

import "./imageUpload.vue?vue&type=style&index=0&id=fef8cd04&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fef8cd04"]])

export default __exports__